import { useCallback, useEffect, useRef, useState } from 'react';

export const useConfirmation = <T extends string>(duration = 1500) => {
    const [confirmed, setConfirmed] = useState<T | null>(null);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const showConfirmation = useCallback(
        (key: T) => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            setConfirmed(key);
            timeoutRef.current = setTimeout(() => setConfirmed(null), duration);
        },
        [duration]
    );

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return { confirmed, showConfirmation };
};
